import { render, staticRenderFns } from "./DoccurateItemToPalletPremadePallet.vue?vue&type=template&id=3f7986c5&"
import script from "./DoccurateItemToPalletPremadePallet.vue?vue&type=script&lang=js&"
export * from "./DoccurateItemToPalletPremadePallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports